<template>
    <el-container height="auto">
      <el-header style="height:50px;">
      <el-container style="padding:0px;margin:0px;">
          <el-main style="padding:0px;margin:0px;overflow:hidden;">
            <el-form ref="form" :inline="true" :model="form" :rules="rules"  label-width="100px">
              <!-- <el-form-item label="应用类别">
              <el-select v-model="form.category" placeholder="请选择类别" disabled>
                <el-option label="病例应用" value="SUBJECT"></el-option>
                <el-option label="研究应用" value="PROJECT"></el-option>
              </el-select>
              </el-form-item> -->
              <el-form-item>
                <el-button type="primary" @click="onSave">保存</el-button>
                <el-button type="default" @click="onSaveAs">另存</el-button>

                  {{showversioninfo}}
                <el-link v-if="this.versioncontent != ''" type="primary"  :underline="false" @click="cancelviewversion"><i class="fa fa-undo"></i>&nbsp;关闭预览</el-link>
              </el-form-item>
            </el-form>
          </el-main>
          <el-aside style="width:200px;padding-top:8px;">
              

            <el-row type="flex">
          
              <el-col :span="12">
                <el-popover
                
                >
        
                    <el-table
                      :data="formhistory"
                      highlight-current-row
                      @row-click="formhistory_rowclick"
                      style="width: 100%" 
                      max-height="200"
                    >
                      <el-table-column
                        label=""
                        type="index"
                        :index="indexMethod">
                      </el-table-column>
                      <el-table-column prop="createddate" label="时间" width="250px">
                        <template slot-scope="scope">
                          {{scope.row.createddate}}&nbsp;
                          <span style="color:#aabbcc">{{$moment(scope.row.createddate).fromNow()}}</span>
                          
                        </template>
                      </el-table-column>
                      <el-table-column prop="username" label="最近" width="100px">
                      </el-table-column>
                      <el-table-column prop="operation" label="操作" width="100px">
                        <i class="fa fa-eye"></i>&nbsp;点击预览
                        <!-- <template slot-scope="scope">
                          <el-link :underline="false" @click="viewversion(scope.row)"></el-link>
                            
                        </template> -->
                      </el-table-column>
                    </el-table>
                 
                    <el-link slot="reference" :underline="false"><i class="fa fa-history"></i>&nbsp;历史版本</el-link>

                </el-popover>
                
              </el-col>
              <el-col :span="12"><el-link @click="onTemplate" :underline="false"><i class="fa fa-plus"></i>&nbsp;添加模板库</el-link></el-col>
            </el-row>
              
            
          </el-aside>
      </el-container>
    </el-header>
    <el-main style="overflow:hidden;">
   
         <iframe ref="iframe" :src="editorUrl" frameborder="0" scrolling="yes" name="iframe" seamless>您的浏览器版本过低，无法显示报表内容！建议升级浏览器或更换浏览器！</iframe>
    </el-main>
  </el-container>

</template>
<script>
  export default {
    data() {
      return {
        editorUrl: '',
        
        form: {
          //name: '我的新表单',
          //category: 'SUBJECT',
          //description: '',
          //content: ''
        },

        rules: {
          name: [
            { required: true, message: '请输入名称', trigger: 'blur' },
            { min: 5, max: 50, message: '长度在 5 到 50 个字符', trigger: 'blur' }
          ],
          category: [
            { required: true, message: '请选择类别', trigger: 'change' }
          ],
          description: [
            { required: true, message: '请填写备注信息', trigger: 'blur' }
          ]
        },
        formhistory:[],
        showversioninfo:'',
        versioncontent:'',
        formcontent:'',
      }
    },
    mounted() {
      this.loadForm();
      this.loadFormVersionList();
    },
    methods: {
      onSave(){
          var str = this.$refs.iframe.contentWindow.Save();
          var formContent = JSON.parse(str);

          this.$http.get('form/checkname', {params:{name:formContent.form.title}}).then((res)=>{
              if(!res) return;

              var id = parseInt(res.data.formid);

              if(id > 0 && id != parseInt(this.form.formid))
              {
                this.$message({ type:'error', message: '[' + formContent.form.title + ']已经使用过,请使用其他名称.'});
                return;
              }

              this.form.name = formContent.form.title;
              this.form.content = str;

              this.$http.post('form/edit', this.form).then((res) => {
                  if(!res) return;

                  //提醒成功
                  this.$message({ type:'success', message:'表单('+ this.form.name +')保存修改成功.'});
                  //this.goBack(this.form.category);

                  //版本信息更新
                  this.versioncontent = "";
                  this.showversioninfo = "";
                  this.loadFormVersionList();
              }); 
          });
      },
      onSaveAs(){
          var str = this.$refs.iframe.contentWindow.Save();
          var formContent = JSON.parse(str);

          this.$http.get('form/checkname', {params:{name:formContent.form.title}}).then((res)=>{
              if(!res) return;

              var id = parseInt(res.data.formid);

              if(id>0)
              {
                this.$message({ type:'error', message: '[' + formContent.form.title + ']已经使用过,请使用其他名称.'});
                return;
              }

              this.form.name = formContent.form.title;
              this.form.content = str;
              this.$http.post('form/new', this.form).then((res) => {
                  if(!res) return;
                  
                  var info = res.data.info;

                  //提醒成功
                  this.$message({ type:'success', message:'另存表单('+ this.form.name +')成功.'})
                  
                  this.form = info;
                  //更新路由(强制)
                  
                  this.$router.push({path:'/form/edit',query:{id:info.formid}});
                  //this.goBack(this.form.category);
              }); 
          });
      },
      goBack(category) {
        switch(category){
          case "SUBJECT":
            this.$router.push({ name: 'home-subjectform', params: { }})
            break;
          case "PROJECT":
            this.$router.push({ name: 'home-projectform', params: { }})
            break;
          default:
            this.$router.push({ name: 'home-form', params: { }})
            break;
        }

        //this.$router.push({ name: 'home-form', params: { }})
      },
      onTemplate(){
          var str = this.$refs.iframe.contentWindow.Save();
          var formContent = JSON.parse(str);
          this.form.name = formContent.form.title;
          this.form.content = str;
          this.$http.post('form/saveformtemplates', this.form).then((res) => {
              if(!res) return;

              //提醒成功
              this.$message({ type:'success', message:'已添加至模板库,可继续编辑当前表单.'})
          }); 
      },
      loadForm(){
        this.$http.get('form/info', {params:{id:this.$route.query['id']}}).then((res) => { 
            if(!res) return;
            var info = res.data.info;
            this.form = info;
           

            window.content = info.content;
            this.editorUrl = 'formeditor/index.html?' + (new Date()).getTime();
          }); 
      },
      loadFormVersionList(){
         this.$http.get('form/versionlist',{params:{formid:this.$route.query['id']}})
         .then(res=>{
            if(!res)return;
            this.formhistory = res.data.list;

         })
      },
      indexMethod(index) {
        return this.formhistory.length-index;
      },
      formhistory_rowclick(row,event,column){
        //记录版本表单结构
        this.versioncontent = row.content;
        this.showversioninfo = "当前预览版本：" + row.createddate

        this.form.content = this.versioncontent;
        window.content = this.versioncontent;
        this.editorUrl = 'formeditor/index.html?' + (new Date()).getTime();
      },
      cancelviewversion(){
        this.versioncontent = "";
        this.showversioninfo = "";
        
        this.loadForm();
      }
    }
  }
</script>

<style scoped>
iframe {
  width:100%;
  height:100%;
}
</style>